import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';

const $body = $('html, body');
const docEl = document.documentElement;

let breakable = true;
let breakTimeout = null;
let bound = false;

/**
 * Scrolls to a point on the page when an element is clicked.
 *
 * Scrolls to top: <button sw-scroller="top">Top</button>
 * Scrolls to bottom: <button sw-scroller="bottom">Bottom</button>
 * Scrolls to element by ID: <button sw-scroller="#element">Element</button>
 *
 * @param context
 */
export default function scrollerDirective(context=document.body) {
    const $context = $(context);

    $context.find('[sw-scroller]').each(function() {
        const $element = $(this);
        const json = $element.attr('sw-scroller');
        const settings = directiveSettings(json, {
            to: 'top',
            selector: null,
            speed: 500,
			offset: 0
        }, 'to');

        $element.on('click', function(e) {
            e.preventDefault();

            clearInterval(breakTimeout);
            breakable = false;
            breakTimeout = setTimeout(() => breakable = true, 100);

            let top = 0;
            switch (settings.to) {
                case 'top': top = 0; break;
                case 'bottom': top = docEl.scrollHeight - docEl.clientHeight; break;
                case 'element': top = $(settings.selector).offset().top; break;
                default: top = $(settings.to).offset().top;
            }

            $body.animate(
                { scrollTop: Math.min((top - settings.offset), docEl.scrollHeight - docEl.clientHeight) },
                { duration: settings.speed }
            );
        });
    });

    if (!bound) {
        bound = true;
        $body.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', function(e) {
            if (breakable && e.which > 0) {
                switch (e.type) {
                    case 'mousedown':
                    case 'mousewheel':
                    case 'touchstart': $body.stop(); break;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/scroller.js